// extracted by mini-css-extract-plugin
module.exports = {"hub":"faqHubContent_hub__ZrMLv","title":"faqHubContent_title__Z7t64","intro":"faqHubContent_intro__YIkPu"};